import React from "react";
import { Typography } from "@material-ui/core";
import { fieldTypes } from "@icarius-utils/constants";
import { useSelector } from "react-redux";
import { getUserData } from "@icarius-app/selectors";
import { getLocalizedString } from "@icarius-localization/strings";
import { formatNumberExactDecimals } from "@icarius-utils/format";
import { formatDate } from "@icarius-utils/date";

const ReadOnlyInput = (props) => {
    const { label, value, type, addressHref, fieldConfig } = props;

    const userData = useSelector(getUserData);

    if (type === fieldTypes.email) {
        return (
            <div style={{ height: 48 }}>
                <Typography className="whiteText" variant="caption">
                    {label}
                </Typography>
                <Typography className="whiteText">
                    {value && value !== "-" ? (
                        <a
                            className="whiteText"
                            target="_blank"
                            rel="noopener noreferrer"
                            href={`mailto:${value}?subject=${getLocalizedString("messageFrom")}${userData.name}`}
                        >
                            {value}
                        </a>
                    ) : (
                        <span>-</span>
                    )}
                </Typography>
            </div>
        );
    }

    if (type === fieldTypes.phone) {
        return (
            <div style={{ height: 48 }}>
                <Typography className="whiteText" variant="caption">
                    {label}
                </Typography>
                <Typography className="whiteText">
                    {value && value !== "-" && value !== "+" ? (
                        <a className="whiteText" target="_blank" rel="noopener noreferrer" href={`tel: ${value}`}>
                            {value}
                        </a>
                    ) : (
                        <span>-</span>
                    )}
                </Typography>
            </div>
        );
    }

    if (type === fieldTypes.address) {
        return (
            <div style={{ height: 48 }}>
                <Typography className="whiteText" variant="caption">
                    {label}
                </Typography>
                <Typography className="whiteText">
                    {value && addressHref ? (
                        <a className="whiteText" target="_blank" rel="noopener noreferrer" href={addressHref}>
                            {value}
                        </a>
                    ) : (
                        <span className={"value"}>{value || "-"}</span>
                    )}
                </Typography>
            </div>
        );
    }

    if (type === fieldTypes.number) {
        const decimals = fieldConfig && fieldConfig.decimals ? fieldConfig.decimals : 0;
        return (
            <div style={{ height: 48 }}>
                <Typography className="whiteText" variant="caption">
                    {label}
                </Typography>
                <Typography className="whiteText">
                    {formatNumberExactDecimals(parseFloat(value), decimals) || "-"}
                </Typography>
            </div>
        );
    }

    if (type === fieldTypes.check) {
        return (
            <div style={{ height: 48 }}>
                <Typography className="whiteText" variant="caption">
                    {label}
                </Typography>
                <Typography className="whiteText">
                    {value ? getLocalizedString("yes") : getLocalizedString("no")}
                </Typography>
            </div>
        );
    }

    if (type === fieldTypes.date) {
        return (
            <div style={{ height: 48 }}>
                <Typography className="whiteText" variant="caption">
                    {label}
                </Typography>
                <Typography className="whiteText">
                    {value ? formatDate(value) : getLocalizedString("noUpdateDateRecorded")}
                </Typography>
            </div>
        );
    }

    if (Array.isArray(value)) {
        const text = value
            .map((val) => {
                const opt = (fieldConfig?.options || []).find((o) => {
                    const key = o.id !== undefined ? o.id : o.key;
                    return key === val || String(key) === String(val);
                });
                return opt ? opt.value : val;
            })
            .join(", ");
        return (
            <div style={{ height: 48 }}>
                <Typography className="whiteText" variant="caption">
                    {label}
                </Typography>
                <Typography className="whiteText">{text || "-"}</Typography>
            </div>
        );
    }

    return (
        <div style={{ height: 48 }}>
            <Typography className="whiteText" variant="caption">
                {label}
            </Typography>
            <Typography className="whiteText">{value || "-"}</Typography>
        </div>
    );
};

export default ReadOnlyInput;
